export const isProduction = () => process.env.NODE_ENV === "production";

export const frontBaseUrl = process.env.REACT_APP_FRONT_URL;
